import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccessLLMModel } from "models/IAccessLLMModel";

interface IAILLMModelsState {
  value: IAccessLLMModel[];
  isLoading: boolean;
}

const initialState: IAILLMModelsState = {
  value: [],
  isLoading: true,
};

export const aiLLMModelsSlice = createSlice({
  name: "aiLLMModels",
  initialState,
  reducers: {
    setAIModels: (state, action: PayloadAction<IAccessLLMModel[]>): void => {
      state.value = action.payload;
      state.isLoading = false;
    },
    addAIModel: (state, action: PayloadAction<IAccessLLMModel>): void => {
      state.value.push(action.payload);
    },
    updateAIModelInSlice: (
      state,
      action: PayloadAction<IAccessLLMModel>,
    ): void => {
      const index: number = state.value.findIndex(
        (model: IAccessLLMModel): boolean => model.id === action.payload.id,
      );
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeAIModel: (state, action: PayloadAction<string>): void => {
      state.value = state.value.filter(
        (model: IAccessLLMModel): boolean => model.id !== action.payload,
      );
    },
  },
});

export const { setAIModels, addAIModel, updateAIModelInSlice, removeAIModel } =
  aiLLMModelsSlice.actions;

export default aiLLMModelsSlice.reducer;
